export const GET_DISCOUNTS = 'GET_DISCOUNTS';
export const DISCOUNTS_FETCH_ERROR = 'DISCOUNTS_FETCH_ERROR';
